import { Component, OnInit } from '@angular/core';
import { ConsumidorModel, ConsumidorService } from '../shared';

import { UtilHelper } from '../../../shared';

@Component({
  selector: 'app-consumidor-cartao',
  templateUrl: './consumidor-cartao.component.html',
  styleUrls: ['./consumidor-cartao.component.css']
})
export class ConsumidorCartaoComponent implements OnInit {

  public consumidorModel: ConsumidorModel;

  constructor(private readonly consumidorService: ConsumidorService) { }

  ngOnInit() {
    this.consumidorModel = this.consumidorService.getConsumidorModel();
    this.consumidorModel.cpf = UtilHelper.lpad(this.consumidorModel.cpfBase.toString(), 9) + '' +
      UtilHelper.lpad(this.consumidorModel.cpfDigito.toString(), 2);
  }



}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-cartao/consumidor-cartao.component.ts